import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');
        let config = {
            slidesPerView: 1,
            watchOverflow: true,
            observer: true,
            allowTouchMove: true,
            effect: 'fade',
            autoHeight: true,
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: this.element.querySelector("[data-swiper-nav='next']"),
                prevEl: this.element.querySelector("[data-swiper-nav='prev']"),
            },
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({EffectFade , Navigation}) => {
                Swiper.use([EffectFade, Navigation]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}